<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-{{color}}-3">
                        <h4 class="card-title">Canceled Orders</h4>
                        <p class="card-category"></p>
                    </div>
                    <div class="card-body">
                        <ng-template #orderDetails let-modal>
                <div class="modal-header" [ngClass]="{'bg-danger text-white': orderdetails.header.orderstatusid == 90}">
                    <div class="modal-title row m-0 p-0" id="modal-title">
                        <h4>Order# {{orderdetails.header.orderno}} 
                            <ng-container *ngIf="orderdetails.cancelreason?.label">
                                <br/>
                                 Reason: {{orderdetails.cancelreason.label}} 
                                 <ng-container *ngIf="orderdetails.cancelreason?.notes">
                                    "{{orderdetails.cancelreason?.notes}}"
                                 </ng-container> 
                            </ng-container>
                        </h4>
                    </div>
                    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                        <i class="fa fa-close"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="mb-3" *ngIf="orderdetails">
                        <div *ngIf="orderdetails.dispatch_details && orderdetails.dispatch_details.status_id == '29'">
                            <div #mapDiv class="w-100" [ngClass]="{'d-none': !orderdetails.dispatch_details.nextlast}">
                                EST: {{orderdetails.dispatch_details.nextlast}}
                                <div class="w-100" id="map"></div>
                            </div>
                        </div>
                        <div class="row border-bottom pb-2">
                            <div class="col-md-3 text-center">
                                <h5>Ship Via: {{ orderdetails.header.shippername }}</h5>
                            </div>
                            <div class="col-md-3 text-center">
                                <h5>Date Wanted: {{ orderdetails.header.datewanted }}</h5>
                            </div>
                            <div class="col-md-3 text-center">
                                <h5>Entered By: {{ orderdetails.header.enteredby }}</h5>
                                <br/>
                                <h5>Canceled By: {{orderdetails.cancelreason.userid}}</h5>
                            </div>
                            <div class="col-md-3 text-center">
                                <h5>Created: {{ orderdetails.header.date_created }}</h5>
                                <br/>
                                <h5>Canceled: {{orderdetails.cancelreason.created_at}}</h5>
                            </div>
                        </div>

                        <div class="row mt-2 mb-2 border-bottom pb-2">
                            <div class="col-md-3">
                                <h5 class="mb-0">Ship To:</h5>
                                <mat-divider></mat-divider>
                                <span class="mt-2 lesser" [innerHTML]="orderdetails.header.shipto"></span>
                            </div>
                            <div class="col-md-3">
                                <h5 class="mb-0">Phone:</h5>
                                <mat-divider></mat-divider>
                                <span class="mt-2 lesser">{{orderdetails.header.contactphone}}</span>

                                <ng-container
                                    *ngIf="orderdetails.header.contactemail && orderdetails.header.contactemail != ''">
                                    <h5 class="mb-0 mt-2">Email:</h5>
                                    <mat-divider></mat-divider>
                                    <span class="mt-2 lesser">
                                        <a
                                            [href]="'mailto:' + orderdetails.header.contactemail">{{orderdetails.header.contactemail}}</a>
                                    </span>
                                </ng-container>
                            </div>
                            <div class="col-md-3">
                                <h5 class="mb-0">Notes:</h5>
                                <mat-divider></mat-divider>
                                <span class="mt-2 lesser" [innerHTML]="orderdetails?.header?.comments"></span>
                            </div>
                            <div class="col-md-3">
                                <h5 class="mb-0 lesser">History:</h5>
                                <mat-divider></mat-divider>
                                <ng-container *ngIf="orderdetails.dispatch_details.dispatch_id">
                                    <ul class="mt-2">
                                        <li *ngIf="orderdetails.dispatch_details.truck_name">
                                            ShipVia: {{ orderdetails.dispatch_details.truck_name }}<br>
                                            {{ orderdetails.dispatch_details.driveruserid }}
                                        </li>
                                        <li *ngIf="orderdetails.dispatch_details.datecreated !='0000-00-00 00:00:00'">
                                            Dispatched: {{ orderdetails.dispatch_details.datecreated | date:'shortDate'
                                            }}
                                            {{ orderdetails.dispatch_details.datecreated | date:'shortTime' }}
                                        </li>
                                        <li *ngIf="orderdetails.dispatch_details.delivery_date !='0000-00-00 00:00:00'">
                                            Delivered: {{ orderdetails.dispatch_details.delivery_date | date:'shortDate'
                                            }}
                                            {{ orderdetails.dispatch_details.delivery_date | date:'shortTime' }}
                                        </li>
                                    </ul>
                                </ng-container>
                                <ng-container *ngIf="!orderdetails.dispatch_details.dispatch_id">
                                    N/A
                                </ng-container>
                            </div>
                        </div>
                        <div class="table-responsive mt-3">
                            <table class="table table-bordered table-striped table-hover normal">
                                <thead class="thead-dark">
                                    <tr>
                                        <th>ITEM</th>
                                        <th>DESC</th>
                                        <th class="text-center">QOH</th>
                                        <th class="text-center">ORDERED</th>
                                        <th class="text-center">INVOICED</th>
                                        <th class="text-center">OUTSTANDING</th>
                                        <th class="text-right">PRICE</th>
                                        <th class="text-right" *ngIf="config.discounts">DISCOUNT</th>
                                        <th class="text-right">TOTAL</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of orderdetails.details">
                                        <td>
                                            <button mat-icon-button (click)="copyToClipboard(item.stkcode)" class="ml-2"
                                                title="Copy to clipboard">
                                                <mat-icon>content_copy</mat-icon>
                                            </button>
                                            <a [routerLink]="'/inventory/view/'+item.stkcode"
                                                (click)="modal.dismiss('route change')">{{item.stkcode}}</a>
                                        </td>
                                        <td>{{item.description}}</td>
                                        <td class="text-center">{{item.qoh}}</td>
                                        <td class="text-center">{{item.ordered}}</td>
                                        <td class="text-center">{{item.qtyinvoiced}}</td>
                                        <td class="text-center">{{item.ordered - item.qtyinvoiced}}</td>
                                        <td class="text-right">{{item.unitprice | currency}}</td>
                                        <td class="text-right" *ngIf="config.discounts">{{item.discountpercent | percent
                                            }}</td>
                                        <td class="text-right">{{item.discountprice * item.ordered | currency}}</td>
                                    </tr>
                                </tbody>
                                <tfoot>

                                    <tr *ngFor="let t of orderdetails.saved_totals">
                                        <ng-container *ngIf="config.discounts">
                                            <td colspan="7"></td>
                                        </ng-container>
                                        <ng-container *ngIf="!config.discounts">
                                            <td colspan="6"></td>
                                        </ng-container>
                                        <td class="text-right">{{ t.title }}:</td>
                                        <td class="text-right">{{t.text | currency}}</td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="modal-footer"></div>
            </ng-template>

            <ng-template #purchaseOrderDetails let-modal>
                <div class="modal-header">
                    <h4 class="modal-title" id="modal-title" *ngIf="podetails">
                        <a [routerLink]="'/vendors/'+podetails.poheader.supplierno">{{ podetails.poheader.supplierno
                            }}</a>
                        Purchase Order
                    </h4>
                    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                        <i class="fa fa-close"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <mat-tab-group #tabPanel mat-align-tabs="start" color="accent" class="no-overflow">
                        <!-- Purchase Order Tab -->
                        <mat-tab label="Purchase Order">
                            <div class="mb-3" *ngIf="podetails">
                                <h4 class="mt-3">PO #{{ podetails.poheader.orderno }}</h4>
                                <div class="card-deck mt-3">
                                    <div class="card col-6">
                                        <div class="card-header">
                                            <strong>Contact Information</strong>
                                        </div>
                                        <div class="card-body">

                                            <p class="card-text">
                                                <strong>Contact:</strong> {{podetails.poheader.contact}}<br>
                                                <strong>Address:</strong>
                                                <ng-container *ngIf="podetails.address">
                                                    <div [innerHTML]="podetails.address"></div>
                                                </ng-container>
                                            </p>
                                            <!-- <p><strong>Supplier Delivery Address:</strong>
                                            <ng-container *ngIf="podetails.poheader.suppdeladdress1">{{podetails.poheader.suppdeladdress1}}<br></ng-container>
                                            <ng-container *ngIf="podetails.poheader.suppdeladdress2">{{podetails.poheader.suppdeladdress2}}<br></ng-container>
                                            <ng-container *ngIf="podetails.poheader.suppdeladdress3">{{podetails.poheader.suppdeladdress3}},</ng-container>
                                            <ng-container *ngIf="podetails.poheader.suppdeladdress4">{{podetails.poheader.suppdeladdress4}}</ng-container>
                                            <ng-container *ngIf="podetails.poheader.suppdeladdress5">{{podetails.poheader.suppdeladdress5}}</ng-container>
                                        </p> -->
                                        </div>
                                    </div>
                                    <div class="card col-6">
                                        <div class="card-header">
                                            <strong>Delivery Information</strong>
                                        </div>
                                        <div class="card-body">
                                            <p class="card-text">
                                                <strong>Delivery Address:</strong><br>
                                                <ng-container
                                                    *ngIf="podetails.poheader.deladd1">{{podetails.poheader.deladd1}}<br></ng-container>
                                                <ng-container
                                                    *ngIf="podetails.poheader.deladd2">{{podetails.poheader.deladd2}}<br></ng-container>
                                                <ng-container
                                                    *ngIf="podetails.poheader.deladd3">{{podetails.poheader.deladd3}},</ng-container>
                                                <ng-container
                                                    *ngIf="podetails.poheader.deladd4">{{podetails.poheader.deladd4}}</ng-container>
                                                <ng-container
                                                    *ngIf="podetails.poheader.deladd5">{{podetails.poheader.deladd5}}</ng-container>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="card col-6">
                                        <div class="card-header">
                                            <strong>Notes</strong>
                                        </div>
                                        <div class="card-body" [innerHTML]="podetails.poheader.stat_comment"></div>
                                    </div>
                                    <div class="card col-6">
                                        <div class="card-header">
                                            <strong>Totals</strong>
                                        </div>
                                        <div class="card-body">
                                            <p class="card-text">
                                                <strong>Total Quantity:</strong> {{ getTotalQuantity() }}<br>
                                                <strong>Total Value:</strong> {{ getTotalValue() | currency }}<br>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-responsive mt-3">
                                    <table class="table table-bordered table-striped table-hover normal" #pdata>
                                        <thead class="thead-dark">
                                            <tr>
                                                <th>ITEM</th>
                                                <th>DESC</th>
                                                <th class="text-center">QTY</th>
                                                <th class="text-center">RCVD</th>
                                                <th class="text-center">PEND</th>
                                                <th class="text-right">PRICE</th>
                                                <th class="text-right">TOTAL</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let item of podetails.polines">
                                                <td>
                                                    <button mat-icon-button (click)="copyToClipboard(item.itemcode)"
                                                        class="ml-2" title="Copy to clipboard">
                                                        <mat-icon>content_copy</mat-icon>
                                                    </button>

                                                    <a [routerLink]="'/inventory/view/'+item.itemcode"
                                                        (click)="modal.dismiss('route change')">
                                                        {{item.itemcode}}
                                                    </a>

                                                </td>
                                                <td>{{item.itemdescription}}</td>
                                                <td class="text-center">{{item.quantityord}}</td>
                                                <td class="text-center">{{item.quantityrecd}}</td>
                                                <td class="text-center">{{item.quantityord - item.quantityrecd}}</td>
                                                <td class="text-right">{{item.unitprice | currency}}</td>
                                                <td class="text-right">{{item.unitprice * item.quantityord | currency}}
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colspan="2"><strong>Total</strong></td>
                                                <td class="text-center"><strong>{{ getTotalQuantity() }}</strong></td>
                                                <td colspan="3"></td>
                                                <td class="text-right"><strong>{{ getTotalValue() | currency }}</strong>
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                        </mat-tab>




                        <!-- Receiving Details Tab -->
                        <mat-tab label="Receiving Details">
                            <ng-container *ngIf="podetails.receiving.length">
                                <table class="table table-fixed table-sm">
                                    <thead>
                                        <tr>
                                            <th>GRN</th>
                                            <th>Order#</th>
                                            <th>Item#</th>
                                            <th>Description</th>
                                            <th>Received</th>
                                            <th>Invoiced</th>
                                            <th>Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let r of podetails.receiving">
                                            <td>{{ r.grnno }}</td>
                                            <td>{{ r.poorderno }}</td>
                                            <td>{{ r.itemcode }}</td>
                                            <td>{{ r.itemdescription }}</td>
                                            <td>{{ r.qtyrecd }}</td>
                                            <td>{{ r.quantityinv }}</td>
                                            <td>{{ r.update_date }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </ng-container>
                            <ng-container *ngIf="!podetails.receiving.length">
                                <p>No Receiving Details</p>
                            </ng-container>
                        </mat-tab>
                        <!-- Receiving Movements Tab -->
                        <mat-tab label="Receiving Movements">
                            <ng-container *ngIf="podetails.movements.length">
                                <table class="table table-fixed table-sm">
                                    <thead>
                                        <tr>
                                            <th>Item#</th>
                                            <th>Location</th>
                                            <th>User</th>
                                            <th>Quantity</th>
                                            <th>QOH</th>
                                            <th>Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let r of podetails.movements">
                                            <td>{{ r.stockid }}</td>
                                            <td>{{ r.loccode }}</td>
                                            <td>{{ r.userid }}</td>
                                            <td>{{ r.qty }}</td>
                                            <td>{{ r.newqoh }}</td>
                                            <td>{{ r.trandate }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </ng-container>
                            <ng-container *ngIf="!podetails.movements.length">
                                <p>No Movements</p>
                            </ng-container>
                        </mat-tab>
                    </mat-tab-group>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" (click)="modal.dismiss('cancel')">Close</button>
                </div>
            </ng-template>

            <div class="filter-row" [class.has-active-filters]="hasActiveFilters()">
                <div class="filter-controls">
                    <ng-container *ngIf="config.env.package === 'tires'">
                        <button mat-raised-button color="primary" [matMenuTriggerFor]="exportmenu"
                            [matTooltip]="'Export open orders?'" [disabled]="!openorders?.data?.length">
                            <mat-icon *ngIf="!exportingOrders">print</mat-icon>
                            <svg *ngIf="exportingOrders" class="spinner" width="35px" height="35px" viewBox="0 0 66 66"
                                xmlns="http://www.w3.org/2000/svg">
                                <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33"
                                    r="30">
                                </circle>
                            </svg>
                        </button>
                        <mat-menu #exportmenu="matMenu" class="m-0 p-0">
                            <button mat-menu-item (click)="buildHtmlAndExport('pdf')">PDF</button>
                            <button mat-menu-item (click)="buildHtmlAndExport('xlsx')">XLSX</button>
                        </mat-menu>
                    </ng-container>

                    <div class="nav-item ml-1">
                        <form class="form-inline my-2 my-lg-0">
                            <mat-form-field appearance="outline">
                                <mat-label>Transaction Dates</mat-label>
                                <mat-date-range-input [rangePicker]="picker">
                                    <input matStartDate [formControl]="fromdateCtrl" placeholder="Start date" (dateChange)="updateRange(true)">
                                    <input matEndDate [formControl]="todateCtrl" placeholder="End date" (dateChange)="updateRange()">
                                </mat-date-range-input>
                                <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker></mat-date-range-picker>
                            </mat-form-field>
                        </form>
                    </div>

                    <mat-form-field appearance="outline">
                        <mat-label>Warehouse</mat-label>
                        <mat-select [formControl]="defaultlocation" (selectionChange)="filterWarehouse($event.value)">
                            <mat-option *ngFor="let loc of locations" [value]="loc.loccode">
                                {{ loc.locationname }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" *ngIf="config.env.package === 'beauty'">
                        <mat-label>Order Source</mat-label>
                        <mat-select [(ngModel)]="selectedOrderSource" (selectionChange)="filterItemSource()">
                            <mat-option [value]="''">All</mat-option>
                            <mat-option *ngFor="let source of orderSources" [value]="source.value">
                                {{ source.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" *ngIf="config.env.package === 'beauty'">
                        <mat-label>Customer Type</mat-label>
                        <mat-select [(ngModel)]="selectedCustomerType" (selectionChange)="filterCustomerType()">
                            <mat-option [value]="''">All</mat-option>
                            <mat-option *ngFor="let ct of customertypes" [value]="ct.typeid">
                                {{ ct.typename }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <!-- <mat-form-field appearance="outline" *ngIf="config.env.package === 'beauty'">
                        <mat-label>Printed</mat-label>
                        <mat-select [(ngModel)]="selectedPrinted" (selectionChange)="filterPrinted()">
                            <mat-option [value]="''">All</mat-option>
                            <mat-option [value]="true">Yes</mat-option>
                            <mat-option [value]="false">No</mat-option>
                        </mat-select>
                    </mat-form-field> -->

                    <mat-form-field appearance="outline" *ngIf="config.env.package === 'beauty'">
                        <mat-label>Reason</mat-label>
                        <mat-select [(ngModel)]="selectedReason" (selectionChange)="filterReason()">
                            <mat-option [value]="''">All</mat-option>
                            <mat-option [value]="reason.code" *ngFor="let reason of predefinedReasons">{{reason.label}}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" *ngIf="shipvias && shipvias.length">
                        <mat-label>ShipVia</mat-label>
                        <mat-select [formControl]="shipvia" (selectionChange)="filterShipVia()" multiple appSelectAll>
                            <mat-option *ngFor="let loc of shipvias" [value]="loc.shipper_id">
                                {{ loc.shippername }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Salespeople</mat-label>
                        <mat-select [formControl]="salespersonRef" (selectionChange)="filterSalesperson()" multiple
                            appSelectAll>
                            <mat-option *ngFor="let sp of salespeople" [value]="sp.salesmancode">
                                {{ sp.salesmanname }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Item Search</mat-label>
                        <input matInput [formControl]="searchInputItems" (input)="searchItems()" placeholder="Search..."
                            class="text-right" appCollapseKeyboard />
                        <span matSuffix>
                            <button mat-icon-button (click)="searchItems()">
                                <mat-icon>search</mat-icon>
                            </button>
                        </span>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Order Search</mat-label>
                        <input matInput [formControl]="searchInput" (keydown)="onKeydown($event)"
                            placeholder="Search..." class="text-right" appCollapseKeyboard />
                        <span matSuffix>
                            <button mat-icon-button (click)="search()">
                                <mat-icon>search</mat-icon>
                            </button>
                        </span>
                        <span matSuffix>
                            <button mat-icon-button (click)="loadData()">
                                <mat-icon *ngIf="!subscriptionActive">refresh</mat-icon>
                                <ng-container *ngIf="subscriptionActive">
                                    <svg class="d-block" width='18px' height='18px' viewBox='0 0 66 66' xmlns='http://www.w3.org/2000/svg'> <circle class='path' fill='none' stroke-width='6' stroke-linecap='round' cx='33' cy='33' r='30'></circle> </svg>
                                </ng-container>
                            </button>
                        </span>
                    </mat-form-field>
                </div>



                <div class="filter-actions">
                    <button mat-raised-button color="warn" (click)="clearAllFilters()"
                        [matTooltip]="hasActiveFilters() ? 'Active filters: ' + getActiveFiltersSummary().join(', ') : 'Clear all filters'"
                        [disabled]="!hasActiveFilters()">
                        <mat-icon>clear_all</mat-icon>
                        Clear Filters
                        <span *ngIf="hasActiveFilters()" class="filter-count">({{ getActiveFiltersCount() }})</span>
                    </button>
                </div>

            </div>


            <ng-container *ngIf="config.env.package === 'beauty'">
                <div class="row w-100 m-0" [ngClass]="{'mb-2': !openOrderData.length}">
                    <div class="col-6 m-0 p-0 align-content-center" [ngClass]="{'d-none': !openOrderData.length}">
                        <button class="float-left btn-small text-white btn-success" mat-stroked-button (click)="buildHtmlAndExport('xls')"><i class="fa fa-file-excel-o"></i> XLSX</button>
                        <button class="float-left btn-small text-white btn-danger ml-1" mat-stroked-button (click)="buildHtmlAndExport('pdf')"><i class="fa fa-file-pdf-o"></i> PDF</button>
                    </div>
                    <div class="col-6 m-0 p-0 justify-content-end">
                        <mat-paginator [ngClass]="openOrderData.length ? '': 'd-none'" [pageSizeOptions]="[100, 500, 1000]" showFirstLastButtons aria-label="select page"></mat-paginator>
                    </div>
                </div>
                
            </ng-container>

            <div class="table table-responsive text-center" *ngIf="!openorders">
                <svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                    <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30">
                    </circle>
                </svg>
            </div>

            <div class="row" *ngIf="!openOrderData">
                <div class="col-md-12">
                    <mat-spinner *ngIf="loading"></mat-spinner>
                    <h4 class="mt-3 text-center" *ngIf="!loading">No Open Orders</h4>
                </div>
            </div>


            <div class="table-container w-100">
                <table mat-table [dataSource]="openorders" matSort (matSortChange)="announceSortChange($event)"
                    [ngClass]="openOrderData ? 'w-100 smallertable': 'd-none'">

                    <ng-container matColumnDef="orderno">

                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Order#
                        </th>
                        <td mat-cell *matCellDef="let tran">

                            <mat-checkbox (change)="toggleOrderSelection($event, tran)" [checked]="isSelected(tran)"
                                *ngIf="isMerging"></mat-checkbox>

                            <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Actions">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item (click)="viewInvoicedOrder(tran.orderno, orderDetails, tran.details.cancelreason)">
                                    <mat-icon>visibility</mat-icon>
                                    <span>View</span>
                                </button>
                                <mat-divider></mat-divider>
                                <a href="{{pickinglink}}{{tran.orderno}}&{{ispos}}" mat-menu-item
                                    *ngIf="!issalesman && !isPosUser">
                                    <mat-icon>assignment</mat-icon>
                                    <span>View Pick</span>
                                </a>
                            </mat-menu>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="statusname">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Order#/Status</th>
                        <td mat-cell *matCellDef="let tran">
                            <b>{{ tran.orderno }}</b>
                            <br>
                            <ng-container
                                *ngIf="config.env.package == 'tires' && tran.orderstatusid == '53' && tran.picked">
                                <span class="status-21">
                                    PICKED
                                </span>
                                <br />
                            </ng-container>
                            <span class="status-{{ tran.orderstatusid }}" [ngStyle]="tran | statusBadgeNgStyle">
                                {{ tran.statusname }}
                            </span>
                            &nbsp;&nbsp;<i class="fa fa-edit" (click)="toggleEdit(tran)"
                                *ngIf="tran.orderstatusid !='50' && !issalesman"></i>

                            <ng-container *ngIf="tran.edit">
                                <mat-form-field appearance="outline">
                                    <mat-label>Status</mat-label>
                                    <mat-select [formControl]="order_status_edit">
                                        <mat-option *ngFor="let s of order_statuses" [value]="s.order_status_id">
                                            {{ s.name }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <button class="btn btn-sm btn-danger" (click)="saveStatusUpdate(tran)">
                                    <i class="fa fa-save"></i>
                                </button>
                            </ng-container>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="reason">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left">Reason</th>
                        <td mat-cell *matCellDef="let tran" class="text-left smallest">
                            {{tran.details.cancelreason.label}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="pickprinted">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Printed</th>

                        <td mat-cell *matCellDef="let tran" class="text-center smallest">
                            <ng-container *ngIf="tran.snoozed == '1' ">
                                <mat-icon>notifications_active</mat-icon>
                            </ng-container>
                            <ng-container *ngIf="tran.snoozed != '1' ">
                                <ng-container *ngIf="tran.printedpackingslip == 0">
                                    <span class="text-danger">N</span>
                                </ng-container>
                                <ng-container *ngIf="tran.printedpackingslip == 1">
                                    Y
                                </ng-container>
                                <ng-container *ngIf="tran.printedpackingslip == ''">

                                </ng-container>
                            </ng-container>
                        </td>

                    </ng-container>
                    <ng-container matColumnDef="deliverto">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Ship to</th>
                        <td mat-cell *matCellDef="let tran">
                            <div [innerHTML]="tran.shipto + '<pre>\n</pre>' + tran.details.deliverto"
                                (click)="viewCustomer(tran.debtorno)"></div>

                        </td>
                    </ng-container>
                    <ng-container matColumnDef="datecreated">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Wanted/Created</th>
                        <td mat-cell *matCellDef="let tran" class="wanted-cell">
                            <ng-container *ngIf="tran.orderstatusid != '3'">
                                <div class="info-row">
                                    <span class="info-label">Wanted:</span>
                                    <span class="info-value  date-label">{{ tran.deliverydate }}</span>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="tran.orderstatusid == '3'">
                                <div class="info-row">
                                    <span class="info-label">Wanted:</span>
                                    <span class="info-value  date-label">{{ tran.details.quotedate | date: 'M/d/YYYY' }}</span>
                                </div>
                            </ng-container>
                            <div class="info-row">
                                <span class="info-label">Created:</span>
                                <span class="info-value  date-label">{{ tran.date_created | date:'shortDate' }} {{ tran.date_created | date:'shortTime' }}</span>
                            </div>
                            <div class="info-row">
                                <span class="info-label">Canceled:</span>
                                <span class="info-value cancel-at ">{{ tran.details.canceled_at | date:'shortDate' }} {{ tran.details.canceled_at | date:'shortTime' }}</span>
                            </div>
                            <ng-container *ngIf="tran && tran.tracking && tran.tracking.length">
                                <div class="tracking-container">
                                    <!-- Show shipped date if applicable -->
                                    <span *ngIf="tran.tracking[0].shipstatus > 0" class="tracking-date">
                                        Shipped: {{ tran.tracking[0].datemon | date:'short' }}
                                    </span>

                                    <!-- Tracking numbers formatted as small colored pills -->
                                    <div class="tracking-list" *ngIf="applicableTracking(tran)">
                                        <span *ngFor="let track of tran.tracking; index as i"
                                            [class]="'tracking-pill ' + getTrackingColor(track.shippername)">
                                            <span class="shipper">{{ track.shippername }}</span> {{ track.trackingnumber
                                            }}
                                            <span class="order-bound-indicator"
                                                [ngClass]="{'text-dark': track.shippername.toUpperCase() === 'UPS'}"
                                                *ngIf="track.bind == 1">BINDED</span>
                                        </span>
                                    </div>
                                </div>
                            </ng-container>

                            <div class="info-row">
                                <a href="tel://{{ tran.phoneno }}" class="info-link">{{ tran.phoneno }}</a>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="ponumber" class="hide-on-mobile">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer PO#</th>
                        <td mat-cell *matCellDef="let tran" class="d-none d-md-table-cell">{{ tran.ponumber }}</td>
                    </ng-container>

                    <ng-container matColumnDef="shipvia" class="hide-on-mobile">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>ShipVia</th>
                        <td mat-cell *matCellDef="let tran" class="d-none d-lg-table-cell">{{ getShipVia(tran.shipvia)
                            }}</td>
                    </ng-container>

                    <ng-container matColumnDef="haspo">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                            [ngClass]="config.env.package === 'beauty' ? 'd-none':''">Purchase#</th>
                        <td mat-cell *matCellDef="let tran" [ngClass]="config.env.package === 'beauty' ? 'd-none':''">
                            <span [ngClass]="{'po': tran.haspo.length }" *ngFor="let p of tran.haspo">
                                <span (click)="viewPurchaseOrder(p.purchase_orderno)" class="pointer">{{
                                    p.purchase_orderno
                                    }}</span>
                            </span>
                            <span *ngIf="tran.suppliers" [ngClass]="{'po': tran.haspo.length }"><br>{{ tran.suppliers
                                }}</span>

                        </td>
                    </ng-container>
                    <ng-container matColumnDef="notes" class="hide-on-mobile">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Notes</th>
                        <td mat-cell *matCellDef="let tran">
                            <div [innerHTML]="noNewLines(tran.notes)" class=" comments"></div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="comments" class="hide-on-mobile">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="d-none d-lg-table-cell"> Comments
                        </th>
                        <td mat-cell *matCellDef="let tran" class="d-none d-lg-table-cell">
                            <div [innerHTML]="tran.comments" class=" comments"></div>
                            <div *ngIf="tran.snoozed == '1' ">
                                {{tran.snoozed_details.date_added | date: 'MM/dd/yyyy' }}
                                <b>{{tran.snoozed_details.initials}}:</b> {{tran.snoozed_details.comments}}
                            </div>

                        </td>
                    </ng-container>
                    <ng-container matColumnDef="takenby" class="hide-on-mobile">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left d-none d-lg-table-cell">
                            Taken By / Canceled By
                        </th>
                        <td mat-cell *matCellDef="let tran" class="text-left d-none d-lg-table-cell active-row">{{ tran.takenby }} 
                            <ng-container *ngIf="tran.details.cancelreason.userid">
                                &nbsp;/&nbsp;{{tran.details.cancelreason.userid ?? ''}}
                            </ng-container> 
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="total">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            <ng-container *ngIf="config.env.package === 'tires'">
                                Total
                            </ng-container>
                            <ng-container *ngIf="config.env.package !== 'tires'">
                                SubTotal
                            </ng-container>
                        </th>
                        <td mat-cell *matCellDef="let tran">
                            <ng-container *ngIf="config.env.package === 'tires'">
                                {{ tran.total | currency}}
                            </ng-container>
                            <ng-container *ngIf="config.env.package !== 'tires'">
                                {{ (tran.usetotal == 1 ? tran.total : tran.subtotal) | currency}}
                            </ng-container>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="void" *ngIf="!issalesman">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                            [ngClass]="!config.arpreauth ? 'd-none' : ''">
                        </th>
                        <td mat-cell *matCellDef="let tran"
                            [ngClass]="!config.arpreauth && config.env.package === 'beauty' ? 'd-none' : 'text-right'">
                            <button mat-raised-button class="void-button"
                                (click)="voidPreAuth(tran.orderno); tran.orderstatusid = 1;"
                                *ngIf="tran.orderstatusid === '53'">
                                <mat-icon>cancel</mat-icon> VOID
                            </button>

                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="headercolumns;sticky: true;"></tr>
                    <tr mat-row *matRowDef="let row; columns: headercolumns"
                        [ngClass]="'placedfrom-' + row.details.placedfrom" class="active-row">
                    </tr>
                </table>
                <table *ngIf="openOrderData && !openOrderData.length">
                    <tr>
                        <td>
                            <h4 class="mt-2 text-center">No Canceled Orders</h4>
                        </td>
                    </tr>
                </table>
                <ng-container *ngIf="config.env.package == 'tires'">
                    <mat-paginator [ngClass]="openOrderData ? '': 'd-none'" [pageSizeOptions]="[100, 500, 1000]"
                        showFirstLastButtons aria-label="select page">
                    </mat-paginator>
                </ng-container>
                <ng-template #posRecRef let-modal>
                    <div class="modal-header">
                        <h4 class="modal-title" id="modal-title">
                            <span *ngIf="thistran">Packing List for Order #{{ thistran.orderno }}</span>
                        </h4>
                        <button type="button" class="btn-close" aria-label="Close"
                            (click)="modal.dismiss('Cross click')">
                            <i class="fa fa-close"></i>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div>
                            <!-- Display pick slip HTML -->
                            <div *ngIf="rechtml" [innerHTML]="rechtml"></div>
                            <div *ngIf="!rechtml" class="text-center">
                                <mat-spinner diameter="40" class="mx-auto"></mat-spinner>
                                <p>Loading pick slip...</p>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" (click)="sendPrint()" *ngIf="rechtml && thistran">
                            <mat-icon>print</mat-icon> Print
                        </button>
                        <button type="button" class="btn btn-secondary" (click)="modal.dismiss('cancel')">
                            Close
                        </button>
                    </div>
                </ng-template>
            </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>